(function TripSummaryComponentDescription($, Adzuki)
{
	'use strict';

	// keep in sync with the max-height of .ts-desc-clamp in agent/_itinerary.scss
	const CLAMP_HEIGHT = 140;

	const component = {
		inject: [
			'getFaIconStyle',
		],
		emits: [
			'updateComponentDescription',
		],
		props: {
			component: {
				type    : Object,
				required: true,
			},
			isEmbarkationCruise: {
				type    : Boolean,
				required: true,
				default : false,
			},
		},
		template: '#ts-component-description',
		data() {
			return {
				mode         : 'view',
				expanded     : false,
				isOverflowing: false,
			};
		},
		computed: {
			componentDescription() {
				let description = this.component.description;

				// for a non-embarkation cruise, it should be the cruise day
				if (
					this.component.component_type === 'cruise'
					&& !this.isEmbarkationCruise
					&& this.component.details
				) {
					description = this.component.details.cruise_days;
				}

				// for air/rail/transfer it should be the description from the leg
				if (
					(
						this.component.component_type === 'air' ||
						this.component.component_type === 'rail' ||
						(
							this.component.component_type === 'transportation'
							&& (this.component.component_subtype === 'one-way-transfer' || this.component.component_subtype === 'round-trip-transfer')
						)
					)
					&& this.component.details
				) {
					description = this.component.details.description;
				}

				return description;
			},
		},
		methods: {
			async editComponentDescription() {
				// The edit pencil's tooltip is delegated from <body>, so swapping the
				// pencil out for the editor would orphan it on screen. Hide it first.
				$('[data-toggle="tooltip"]').tooltip('hide');

				this.mode = 'update';

				await this.$nextTick();

				const editorSettings = {
					height     : 100,
					editor_type: 'text_formats',
				};

				Adzuki.Editor('#ts-component-description-' + this.component.id, editorSettings);
			},
			async updateDescription() {
				const description       = tinymce.get('ts-component-description-' + this.component.id).getContent();
				let detailId            = null;
				let isEmbarkationCruise = '0';
				let isLeg               = '0';
				let isFirst             = '0';

				if (this.component.details && this.component.details.id) {
					detailId = this.component.details.id;
				}

				if (this.component.component_type === 'cruise' && this.isEmbarkationCruise) {
					isEmbarkationCruise = '1';
				}

				if (this.component.is_leg) {
					isLeg = '1';
				}

				if (this.component.first) {
					isFirst = '1';
				}

				try {
					const url      = '/TripSummaries/updateComponentDescription/' + this.component.fit_builder_component_id;
					const postData = {
						description          : description,
						detail_id            : detailId,
						is_embarkation_cruise: isEmbarkationCruise,
						is_leg               : isLeg,
						is_first             : isFirst,
					};

					const response = await Adzuki.Ajax.post(url, postData);

					if (response.error) {
						return Adzuki.StatusMessage('error', `Error updating description: ${response.error}`);
					}

					const eventData = {
						id                 : this.component.id,
						componentId        : this.component.fit_builder_component_id,
						componentType      : this.component.component_type,
						isEmbarkationCruise: this.isEmbarkationCruise,
						isLeg              : this.component.is_leg,
						isFirst            : this.component.first,
						detailId           : detailId,
						description        : description,
					};

					this.$emit('updateComponentDescription', eventData);

					this.mode = 'view';
				} catch (error) {
					return Adzuki.StatusMessage('error', `Error updating description: ${error}`);
				}
			},
			toggleExpanded() {
				this.expanded = !this.expanded;
			},
			checkOverflow() {
				const el = this.$refs.descBody;

				this.isOverflowing = Boolean(el) && el.scrollHeight > CLAMP_HEIGHT;
			},
		},
		watch: {
			componentDescription() {
				// re-measure (and re-collapse) when the copy changes, e.g. after an edit
				this.expanded = false;
				this.$nextTick(() => this.checkOverflow());
			},
		},
		mounted() {
			this.$nextTick(() => this.checkOverflow());
		},
	};

	Adzuki.VueComponents.TripSummaryComponentDescription = component;
}(jQuery, window.Adzuki || {}));
